import { render, staticRenderFns } from "./Epayments.vue?vue&type=template&id=665f6170&scoped=true"
import script from "./Epayments.vue?vue&type=script&lang=js"
export * from "./Epayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f6170",
  null
  
)

export default component.exports